// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"ef39312d","160":"2ec88b62","195":"b6436899","208":"cfef0665","293":"fbd3f764","411":"8edc863e","453":"825f87ec","516":"b0bb212a","519":"83d6b2ea","917":"ec07250e","946":"6f44224c"}[chunkId] + ".chunk.js";
};